import { actionTypes } from "../../../types";

const initialState = {
    loading: false,
    status: '',
    message: '',
    data: [],
}

export default (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.TXN_STATUS_REQUEST:
            return {
                ...state,
                loading: true,
            }
        case actionTypes.TXN_STATUS_SUCCESS:
            return {
                ...state,
                loading: false,
                status: action?.payload?.status,
                message: action?.payload?.message,
                data: action?.payload?.response
            }
        case actionTypes.TXN_STATUS_FAILURE:
            return {
                ...state,
                loading: false,
                status: action?.payload?.status,
                message: action?.payload?.message,
            }
        case actionTypes.TXN_STATUS_RESET:
            return {
                ...state,
                status: '',
                message: ''
            }
        case actionTypes.TXN_STATUS_RESET_ALL:
            return initialState
        default:
            return state;
    }
};
